import ComponentRowRender from '../../../../../../../baseComponents/ComponentRowRender'
import { ComponentRowRenderSchema } from '../../../../../../../baseComponents/ComponentRowRender/types'
import { DisplayPriceNotRounded } from '../../../../../../../baseComponents/Displays/DisplayPrice'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'
import { getConfigParam } from '../../../../../../../utils/reducers/getters'
import { TwinParameters } from '@teinor/erp/types/company/config/parameter'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { CalculatedTotalsSimpleResult } from '@teinor/erp/prices/quote/totals'
interface VatTotalHeaderProps {
    tableData: CalculatedTotalsSimpleResult
    CurrencyId: string
}

const VatTotalHeader: React.FC<VatTotalHeaderProps> = ({ CurrencyId, tableData }) => {
    const decimals = getConfigParam('decimals') as TwinParameters['decimals']
    const optionalsColumns: ComponentRowRenderSchema<CalculatedTotalsSimpleResult> = []
    if (tableData.total_vat2) {
        optionalsColumns.push({
            label: <TwinTrans transKey='vats2'>Impuestos 2</TwinTrans>,
            dataKey: 'total_vat2',
            customRender: (value, allValues) => <DisplayPriceNotRounded value={value} with_vat={false} CurrencyId={CurrencyId} className='input_table_displaynumber_r' />,
            width: 75 + (tableData.total_vat2?.toFixed(decimals).length * 9)
        })
    }
    if (tableData.total_retention) {
        optionalsColumns.push({
            label: <TwinTrans transKey='retention'>Retención</TwinTrans>,
            dataKey: 'total_retention',
            customRender: (value, allValues) => <DisplayPriceNotRounded value={value} with_vat={false} CurrencyId={CurrencyId} className='input_table_displaynumber_r' />,
            width: 75 + (tableData.total_retention?.toFixed(decimals).length * 9)
        })
    }
    const columns: ComponentRowRenderSchema<CalculatedTotalsSimpleResult> = [
        {
            label: <TwinTrans transKey='totalWithoutVat'>Base imponible</TwinTrans>,
            dataKey: 'total_without_vat',
            customRender: (value, allValues) => <DisplayPriceNotRounded value={value} with_vat={false} CurrencyId={CurrencyId} className='input_table_displaynumber_r' />,
            width: 150
        },
        {
            label: <TwinTrans transKey='vats'>Impuestos</TwinTrans>,
            dataKey: 'total_vat',
            customRender: (value, allValues) => <DisplayPriceNotRounded value={value} with_vat={false} CurrencyId={CurrencyId} className='input_table_displaynumber_r' />,
            width: 75 + (tableData.total_vat?.toFixed(decimals).length * 9)
        },
        ...optionalsColumns,
        {
            label: <span className='bold18 uppercase'><TwinTrans transKey='total'>Total</TwinTrans></span>,
            dataKey: 'total_total',
            customRender: (value, allValues) => <DisplayPriceNotRounded value={value} with_vat={false} CurrencyId={CurrencyId} className='font-bold input_table_displaynumber_r' />,
            width: 85 + (tableData.total_total?.toFixed(decimals).length * 9)
        }
    ]
    return (
        <div className='bg-gray-F7 flex justify-end px-24 py-8 items-center input_table_footer_header'>
            <ComponentRowRender columns={columns} data={[tableData]} />
        </div>
    )
}

export const VatTotalHeaderNew: React.FC<VatTotalHeaderProps> = ({ CurrencyId, tableData }) => {
    const {t} = useTwinTranslation()
    const optionalsFields: JSX.Element[] = []
    
    if (tableData.total_vat2) {
        optionalsFields.push(
            <SingleFooterRowNew fieldName={t('vats2', 'Impuestos 2') + ':'} element={
                <DisplayPriceNotRounded value={tableData.total_vat2} with_vat={false} CurrencyId={CurrencyId} className='regular18' />
            } />
        )
    }
    if (tableData.total_retention) {
        optionalsFields.push(
            <SingleFooterRowNew fieldName={t('retention', 'Retención') + ':'} element={
                <DisplayPriceNotRounded value={tableData.total_retention} with_vat={false} CurrencyId={CurrencyId} className='regular18' />
            } />
        )
    }

    const renderFields: JSX.Element[] = [
        <SingleFooterRowNew fieldName={t('totalWithoutVat', 'Base imponible') + ':'} element={
            <DisplayPriceNotRounded value={tableData.total_without_vat} with_vat={false} CurrencyId={CurrencyId} className='regular18' />
        } />,
        <SingleFooterRowNew fieldName={t('vats', 'Impuestos') + ':'} element={
            <DisplayPriceNotRounded value={tableData.total_vat} with_vat={false} CurrencyId={CurrencyId} className='regular18' />
        } />,
        ...optionalsFields,
        <SingleFooterRowNew fieldName={t('total', 'Total')} className='medium16 uppercase' element={
            <DisplayPriceNotRounded value={tableData.total_total} with_vat={false} CurrencyId={CurrencyId} className='medium20' />
        } />
    ]

    return (
        <div className='bg-gray-F7 flex flex-wrap-reverse gap-15 justify-between min-h-60 px-24 py-15 items-center input_table_footer_header input_table_footer_header_new'>
            <div className='flex gap-x-30 gap-y-5 flex-wrap ml-auto flex-row items-center justify-between input_table_footer_header_totals_parent'>
                {renderFields}
            </div>
        </div>
    )
}

interface SingleFooterRowNewProps {
    fieldName: string
    element: React.ReactNode
    className?: string
}

const SingleFooterRowNew: React.FC<SingleFooterRowNewProps> = ({fieldName, element, className}) => {
    return (
        <div className='flex flex-auto gap-x-10 whitespace-nowrap items-center justify-end'>
            <div className={'regular14 ' + (className || '')}>{fieldName}</div>
            {element}
        </div>
    )
}


export default VatTotalHeader